import { render, staticRenderFns } from "./ReportImageDamage.vue?vue&type=template&id=0bee0d2c&"
import script from "./ReportImageDamage.vue?vue&type=script&lang=ts&"
export * from "./ReportImageDamage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportImageDamage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports